import { v4 as uuid } from 'uuid';

const DETACHED_PREFIX = 'DETACHED';

export const generateDetachedKey = (id = uuid()) => `${DETACHED_PREFIX}-${id}`;

export const isDetachedKey = (key: string) => key.startsWith(DETACHED_PREFIX);
